import {isFunction} from "lodash";

/**
 * Adding this mixin to a scroll container so it observes elements that have the onVisibilityChange and onPreloadVisibilityChange
 * methods and triggers each function appropriately.
 * onVisibilityChange is called when the element is visible in the viewport.
 * onPreloadVisibilityChange is called when the element is visible within the pre load visibility threshold in this case twice the viewport size.
 */

export default {
	created(){
		this._mutObserver = null;
		this._preObserver = null;
		this._visObserver = null;


		this._mutObserver = new MutationObserver((mutList) => {
			for(let mut of mutList) {
				if(mut.type === 'childList'){
					mut.addedNodes.forEach(node => {
						if(isFunction(node.__vue__?.onVisibilityChange)) {
							//console.log('added node: onVisibilityChange:', node);
							const obs = this.getVisibilityObserver();
							if(obs) obs.observe(node);
						}
						if(isFunction(node.__vue__?.onPreloadVisibilityChange)) {
							//console.log('added node: onPreloadVisibilityChange:', node);
							const obs = this.getPreObserver();
							if(obs) obs.observe(node);
						}
					})

					mut.removedNodes.forEach(node => {
						if(isFunction(node.__vue__?.onVisibilityChange)) {
							//console.log('removed node: onVisibilityChange:', node);
							const obs = this.getVisibilityObserver();
							if(obs) obs.unobserve(node);
						}
						if(isFunction(node.__vue__?.onPreloadVisibilityChange)) {
							//console.log('removed node: onPreloadVisibilityChange:', node);
							const obs = this.getPreObserver();
							if(obs) obs.unobserve(node);
						}
					})
				}
			}
		});
	},
	mounted() {
		this._mutObserver?.observe(this.$el, { attributes: false, childList: true, subtree: true });
	},
	beforeDestroy() {
		this._mutObserver?.disconnect();
		this.getPreObserver()?.disconnect();
		this.getVisibilityObserver()?.disconnect();
	},
	methods:{
		getPreObserver() {
			if(this.$el && !this._preObserver) {
				this._preObserver = new IntersectionObserver((entries) => {
					entries.forEach(entry => {
						if(isFunction(entry.target.__vue__?.onPreloadVisibilityChange)) {
							entry.target.__vue__?.onPreloadVisibilityChange( entry.isIntersecting )
						}
					})
				}, { root: this.$el, rootMargin: "100%" });
			}

			return this._preObserver;
		},
		getVisibilityObserver() {
			if(this.$el && !this._visObserver) {
				this._visObserver = new IntersectionObserver((entries) => {
					entries.forEach(entry => {
						if(isFunction(entry.target.__vue__?.onVisibilityChange)) {
							entry.target.__vue__?.onVisibilityChange( entry.isIntersecting )
						}
					})
				}, { root: this.$el, rootMargin: "0px", threshold: 0.35 });
			}

			return this._visObserver
		}
	}
}
